<template>
  <div class="productSort">
    <!-- <form @submit.prevent="submitForm">
      <div class="header acea-row row-center-wrapper" ref="header">
        <div class="acea-row row-between-wrapper input">
          <span class="iconfont icon-sousuo"></span>
          <input type="text" placeholder="搜索商品信息" v-model="search" />
        </div>
      </div>
    </form> -->
    <!-- <div class="aside">
      <div
        class="item acea-row row-center-wrapper"
        :class="index === navActive ? 'on' : ''"
        v-for="(item, index) in category"
        :key="index"
        @click="asideTap(index)"
      >
        <span>{{ item.cate_name }}</span>
      </div>
    </div> -->

    <div class="container" >
      <div class="swiper-container swiper1">
        <swiper style="width:auto!important" class="swiper-wrapper" :options="swiperProducts">
          <swiper-slide style="width:auto!important;padding: 0 .1rem;"
                  class="swiper-slide"
                  v-for="(item, index) in category"
                  :key="index"
          >
            <div style="margin-right:none;" class="swiper-slide selected" v-if="index == 0">产品分类</div>
            <div v-else>
              <router-link  class="swiper-slide" :to="{
                path: '/CategoryList',
                query: { gid: item.id }
              }"
              >{{ item.cate_name }}</router-link>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>

  <div>
    <div class="bann">
      <img :src="hot_img" />
      </div>
      <!-- <div class="bann">{{}}</div> -->
</div>
     <div class="conter" style="height: 100%;" @scroll.native="onScroll">

        <router-link class="item acea-row row-column row-middle" v-for="(child, index) in goodslist" :key="index" :to="{path: '/detail/' +child.id }">
          <div class="list-box">
            <div class="cont">
              <div class="pictrue" >
                <img :src="child.image" class="on" />
              </div>
              <div class="text">
                <img :src="youUrl"  v-if="child.is_good == 1" class="you" />
                <div class="tit">{{ child.store_name }}</div>
                <div class="tit" style="color:#b3b4af;font-size: .28rem;">{{ child.store_info }}</div>
                <div class="mon">
                  ￥<span class="num">{{ child.price }}</span>
                  <span v-if="child.price > 0">折后价</span>
                  <span class="yuan" v-if="child.price > 0">￥{{ child.price }}</span>
                  <div class="sale" v-if="child.ficti">月销:{{ child.ficti }}</div>
                  <div class="sale" v-else>月销:0</div>
                </div>
                <div class="mon">
                  <div class="label"  v-if="child.is_hot == 1">热卖</div>
                  <div class="label"  v-if="child.is_benefit == 1">促销</div>
                  <div class="label"  v-if="child.is_best == 1">精品</div>
                  <div class="label"  v-if="child.is_new == 1">新品</div>
                  <div class="label"  v-if="child.is_postage == 1">包邮</div>
                </div>
                  <div class="mon">
                  <span class="atext"  v-if="child.pifa_notice" >{{ child.pifa_notice }}</span>
                  <span class="atext"  v-else >品质问题.联系客服</span>
                </div>
              </div>
            </div>
          </div>
        </router-link>

    </div> 
    <div style="height:1.2rem;"></div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import debounce from "lodash.debounce";
import { getCategory } from "@api/store";
import { getUser } from "@api/user";
import { trim } from "../../utils";

export default {
  name: "GoodsClass",
  components: {
      swiper,
      swiperSlide,
  },
  props: {},
  data: function() {
    return {
      youUrl: "http://tieyige.fsrcwl.cn/images/label.png",
      bannerUrl: "http://tieyige.fsrcwl.cn/images/bann.jpg",
      uid:0,
      hot_img:'',
      category: [],
      goodslist: [],
      navActive: 0,
      search: "",
      type:"",
      level:"",
      lock: false,
      tocateid:0,
       swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
    };
  },
  watch: {
    "$route.params.pid": function(n) {
      console.log(n+'参数-----');
      if (n) {
        this.activeCateId(n);
      }
    }
  },
  //监听路由
  watch :{
  　'$route': function (to, from) {
       //执行数据更新查询
       if(to.path=='/category'){
　　    this.loadCategoryData();
       }
　　}
},
  mounted: function() {
    if(typeof(this.$route.query.tocateid)!='undefined'){
      this.tocateid = this.$route.query.tocateid;
    }
    
    this.User();
    document.addEventListener("scroll", this.onScroll, false);
  },
  methods: {
    activeCateId(n) {
      let index = 0;
      n = parseInt(n);
      if (!n) return;
      this.category.forEach((cate, i) => {
        if (cate.id === n) index = i;
      });

      if (index !== this.navActive) {
        this.asideTap(index);
      }
    },
    loadCategoryData() {
      
      var uid=this.uid;
      var type=this.$route.query.type;
      var level=this.$route.query.level;
      this.$set(this, "type", type);
      this.$set(this, "level", level);
      console.log(uid, type, level);
      getCategory({uid:uid,type:type,level:level}).then(res => {
        this.category = res.data.list;
        this.goodslist = res.data.goods_list;
        this.hot_img=res.data.hot_img;
        console.log(res.data.list)
        console.log('-------------------------------')
        this.$nextTick(() => {
          if (this.$route.params.pid) this.activeCateId(this.$route.params.pid);
          else this.onScroll();
          if (this.tocateid) this.activeCateId(this.tocateid);
          else this.onScroll();
        });
      }).catch((e) => {});;
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.uid = res.data.uid;
        this.loadCategoryData();
      });
    },
    submitForm: function() {
      var val = trim(this.search);
      if (val) {
        this.$router.push({
          path: "/goods_list",
          query: { s: val }
        });
        setTimeout(() => (this.search = ""), 500);
      }
    },
    asideTap(index) {
      const top =
        this.$refs.title[index].offsetTop -
        this.$refs.header.offsetHeight -
        window.scrollY;

      this.lock = true;

      window.scrollBy({ top, left: 0, behavior: "smooth" });
      this.navActive = index;
    },
    onScroll: debounce(function() {
      if (this.lock) {
        this.lock = false;
        return;
      }
      const headerHeight = this.$refs.header.offsetHeight,
        { scrollY } = window,
        titles = this.$refs.title;
      titles.reduce((initial, title, index) => {
        if (initial) return initial;
        const parent = title.parentNode || title.parentElement;
        if (
          scrollY + headerHeight + 15 <
          title.offsetTop + parent.offsetHeight
        ) {
          initial = true;
          this.navActive = index;
        }
        // else if (innerHeight + scrollY + 15 > offsetHeight) {
        //   this.navActive = titles.length - 1;
        //   initial = true;
        // }
        return initial;
      }, false);
    }, 500)
  },
  beforeDestroy: function() {
    document.removeEventListener("scroll", this.onScroll, false);
  }
};
</script>
<style scoped>
.productSort .conter .list .item{width: 100%;}
.container{margin:0 auto;}
.swiper1 .swiper-slide{color:#454545}
.productSort .conter .listw{padding:unset}
.bann{width:96%;margin:0 auto;position: relative;overflow: hidden;}
.bann img{width:100%;margin: auto;overflow: hidden;}
.productSort .conter{margin-top: 0;}
.yuan{font-size: 0.26rem;color: #aaa;}
.mon .label{font-size: .23rem;border:1px solid #eee;padding:0 .06rem;border-radius: 16%;color: #ff4200;float: left;margin:0 .03rem}
.mon .atext{color: #a4a4a4;}
.text .you{float: left;margin-right: 0.1rem;width: 30%;border-radius: .05rem;}
/* .swiper-slide{margin-right:.15rem;} */
</style>
